import { render } from "./PublicationsSection.vue?vue&type=template&id=bb2be902&scoped=true"
import script from "./PublicationsSection.vue?vue&type=script&lang=js"
export * from "./PublicationsSection.vue?vue&type=script&lang=js"

import "./PublicationsSection.vue?vue&type=style&index=0&id=bb2be902&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb2be902"]])

export default __exports__